export default "__VITE_ASSET__CYus9BMz__"